__turbopack_context__.v({
  "active": "landing-module__gSp5rG__active",
  "bounce": "landing-module__gSp5rG__bounce",
  "btn-outline": "landing-module__gSp5rG__btn-outline",
  "btn-solid": "landing-module__gSp5rG__btn-solid",
  "campaign-bg": "landing-module__gSp5rG__campaign-bg",
  "campaign-card": "landing-module__gSp5rG__campaign-card",
  "campaign-eyebrow": "landing-module__gSp5rG__campaign-eyebrow",
  "campaign-grid": "landing-module__gSp5rG__campaign-grid",
  "campaign-icon": "landing-module__gSp5rG__campaign-icon",
  "campaign-rule": "landing-module__gSp5rG__campaign-rule",
  "campaign-section-body": "landing-module__gSp5rG__campaign-section-body",
  "campaign-section-title": "landing-module__gSp5rG__campaign-section-title",
  "campaign-sub": "landing-module__gSp5rG__campaign-sub",
  "chateau-appellation": "landing-module__gSp5rG__chateau-appellation",
  "chateau-badge": "landing-module__gSp5rG__chateau-badge",
  "chateau-body": "landing-module__gSp5rG__chateau-body",
  "chateau-card": "landing-module__gSp5rG__chateau-card",
  "chateau-desc": "landing-module__gSp5rG__chateau-desc",
  "chateau-footer": "landing-module__gSp5rG__chateau-footer",
  "chateau-link": "landing-module__gSp5rG__chateau-link",
  "chateau-name": "landing-module__gSp5rG__chateau-name",
  "chateau-photo": "landing-module__gSp5rG__chateau-photo",
  "chateau-photo-overlay": "landing-module__gSp5rG__chateau-photo-overlay",
  "chateau-tag": "landing-module__gSp5rG__chateau-tag",
  "chateau-tags": "landing-module__gSp5rG__chateau-tags",
  "chateau-wines": "landing-module__gSp5rG__chateau-wines",
  "chateaux-grid": "landing-module__gSp5rG__chateaux-grid",
  "container": "landing-module__gSp5rG__container",
  "cta-box": "landing-module__gSp5rG__cta-box",
  "cta-box-btn": "landing-module__gSp5rG__cta-box-btn",
  "cta-box-icon": "landing-module__gSp5rG__cta-box-icon",
  "cta-box-sub": "landing-module__gSp5rG__cta-box-sub",
  "cta-box-title": "landing-module__gSp5rG__cta-box-title",
  "cta-split": "landing-module__gSp5rG__cta-split",
  "final-cta": "landing-module__gSp5rG__final-cta",
  "final-cta-sub": "landing-module__gSp5rG__final-cta-sub",
  "final-cta-title": "landing-module__gSp5rG__final-cta-title",
  "footer": "landing-module__gSp5rG__footer",
  "footer-legal": "landing-module__gSp5rG__footer-legal",
  "footer-links": "landing-module__gSp5rG__footer-links",
  "footer-logo": "landing-module__gSp5rG__footer-logo",
  "footer-tagline": "landing-module__gSp5rG__footer-tagline",
  "hero": "landing-module__gSp5rG__hero",
  "hero-actions": "landing-module__gSp5rG__hero-actions",
  "hero-btn-primary": "landing-module__gSp5rG__hero-btn-primary",
  "hero-btn-secondary": "landing-module__gSp5rG__hero-btn-secondary",
  "hero-eyebrow": "landing-module__gSp5rG__hero-eyebrow",
  "hero-logo": "landing-module__gSp5rG__hero-logo",
  "hero-stat-label": "landing-module__gSp5rG__hero-stat-label",
  "hero-stat-number": "landing-module__gSp5rG__hero-stat-number",
  "hero-stats": "landing-module__gSp5rG__hero-stats",
  "hero-sub": "landing-module__gSp5rG__hero-sub",
  "hero-title": "landing-module__gSp5rG__hero-title",
  "how-bg": "landing-module__gSp5rG__how-bg",
  "how-card": "landing-module__gSp5rG__how-card",
  "how-card-body": "landing-module__gSp5rG__how-card-body",
  "how-card-title": "landing-module__gSp5rG__how-card-title",
  "how-eyebrow": "landing-module__gSp5rG__how-eyebrow",
  "how-grid": "landing-module__gSp5rG__how-grid",
  "how-icon": "landing-module__gSp5rG__how-icon",
  "how-number": "landing-module__gSp5rG__how-number",
  "how-section-body": "landing-module__gSp5rG__how-section-body",
  "how-section-title": "landing-module__gSp5rG__how-section-title",
  "lang-btn": "landing-module__gSp5rG__lang-btn",
  "lang-switch": "landing-module__gSp5rG__lang-switch",
  "map-teaser": "landing-module__gSp5rG__map-teaser",
  "nav": "landing-module__gSp5rG__nav",
  "nav-cta": "landing-module__gSp5rG__nav-cta",
  "nav-links": "landing-module__gSp5rG__nav-links",
  "nav-logo": "landing-module__gSp5rG__nav-logo",
  "ozclub-bg": "landing-module__gSp5rG__ozclub-bg",
  "ozclub-bg-icon": "landing-module__gSp5rG__ozclub-bg-icon",
  "ozclub-cta": "landing-module__gSp5rG__ozclub-cta",
  "ozclub-eyebrow": "landing-module__gSp5rG__ozclub-eyebrow",
  "ozclub-inner": "landing-module__gSp5rG__ozclub-inner",
  "ozclub-tagline": "landing-module__gSp5rG__ozclub-tagline",
  "ozclub-tier": "landing-module__gSp5rG__ozclub-tier",
  "ozclub-tiers": "landing-module__gSp5rG__ozclub-tiers",
  "ozclub-title": "landing-module__gSp5rG__ozclub-title",
  "page": "landing-module__gSp5rG__page",
  "region-pill": "landing-module__gSp5rG__region-pill",
  "regions-grid": "landing-module__gSp5rG__regions-grid",
  "restaurant-body": "landing-module__gSp5rG__restaurant-body",
  "restaurant-card": "landing-module__gSp5rG__restaurant-card",
  "restaurant-city": "landing-module__gSp5rG__restaurant-city",
  "restaurant-desc": "landing-module__gSp5rG__restaurant-desc",
  "restaurant-name": "landing-module__gSp5rG__restaurant-name",
  "restaurant-photo": "landing-module__gSp5rG__restaurant-photo",
  "restaurant-photo-overlay": "landing-module__gSp5rG__restaurant-photo-overlay",
  "restaurant-type": "landing-module__gSp5rG__restaurant-type",
  "restaurants-bg": "landing-module__gSp5rG__restaurants-bg",
  "restaurants-grid": "landing-module__gSp5rG__restaurants-grid",
  "scroll-hint": "landing-module__gSp5rG__scroll-hint",
  "section": "landing-module__gSp5rG__section",
  "section-body": "landing-module__gSp5rG__section-body",
  "section-eyebrow": "landing-module__gSp5rG__section-eyebrow",
  "section-title": "landing-module__gSp5rG__section-title",
  "tier-desc": "landing-module__gSp5rG__tier-desc",
  "tier-icon": "landing-module__gSp5rG__tier-icon",
  "tier-left": "landing-module__gSp5rG__tier-left",
  "tier-name": "landing-module__gSp5rG__tier-name",
  "tier-price": "landing-module__gSp5rG__tier-price",
});
